import { useSelector } from "react-redux";
import "./pvhOverDoc.css";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { INSPECTOR_LIST } from "../../data/inspector_data";

export default function PVHOverDoc() {
  const { selectedInspectorId, formData } = useSelector(
    (state) => state.ins_info
  );

  const selectedInspector =
    INSPECTOR_LIST.find((ins) => ins.id === selectedInspectorId) || null;

  return (
    <div className="pv_hdoc">
      <img className="report_Logo" src="../images/uEnergy.png" alt="Logo"></img>
      <h1 className="report_title">PV Handover Document</h1>

      {/* Basic_info_section */}
      <ul className="table_sv">
        <li className="table_col">
          <h1>PV System Verification Certificate</h1>
          <div className="sv_type">
            <h2>
              {formData.verificationType === "Initial" ? (
                <CheckBoxIcon fontSize="small" color="primary" />
              ) : (
                <CheckBoxOutlineBlankIcon fontSize="small" />
              )}
              &nbsp;Initial Verification
            </h2>

            <h2>
              {formData.verificationType === "Periodic" ? (
                <CheckBoxIcon fontSize="small" color="primary" />
              ) : (
                <CheckBoxOutlineBlankIcon fontSize="small" />
              )}
              &nbsp;Periodic Verification
            </h2>
          </div>
        </li>
      </ul>

      {/* client_information */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Installation Address</h1>
          <h2 className="add_loc">{formData?.installationAddress}</h2>
        </li>
        <li className="table_col">
          <h1>Client Name</h1>
          <h2>{formData?.clientName}</h2>
        </li>
        <li className="table_col">
          <h1>Test Date</h1>
          <h2>{formData?.date}</h2>
        </li>
      </ul>

      {/* contractor_information */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Contractor Address</h1>
          <div className="c_info">
            <p>{selectedInspector?.company}</p>
            <p className="add_loc">{selectedInspector?.address}</p>
            <p>{selectedInspector?.phone}</p>
            <p>{selectedInspector?.email}</p>
          </div>
        </li>
        <li className="table_col">
          <h1>MSC Contact</h1>
          <div className="c_info">
            <p>Telephone: 0333 103 8130</p>
            <p>Email: hello@mcscertified.com</p>
          </div>
        </li>
      </ul>

      {/* system_information */}
      <ul className="table_sec2">
        <li className="table_col">
          <h1>Description of installation (key components installed)</h1>
          <h2>{formData?.description}</h2>
        </li>
        <li className="sys_info">
          <div className="info">
            <h1>Rated power (kW DC)</h1>
            <h2>{formData.power}</h2>
            <h1>IEC 60364-6 inspection report reference:</h1>
            <h2>N/A</h2>
          </div>
          <div className="info">
            <h1>Location</h1>
            <h2>{formData?.location}</h2>
            <h1>IEC 60364-6 test report reference:</h1>
            <h2>{formData?.manualRef}</h2>
          </div>
          <div className="info">
            <h1>Estimated system performance </h1>
            <h2>{formData.estimatedPerformance} kWh /year</h2>
            <h1>PV array inspection report reference:</h1>
            <h2>F43A {formData?.manualRef}</h2>
          </div>
          <div className="info">
            <h1>Circuits tested</h1>
            <h2>{formData?.circuitTested}</h2>
            <h1>PV array test report reference:</h1>
            <h2>F43 {formData?.manualRef}</h2>
          </div>
        </li>
      </ul>

      {/* system_instruction */}
      <ul className="table_sec3">
        <li className="subHead">
          DESIGN, CONSTRUCTION, INSPECTION AND TESTING
        </li>
        <li className="sub_instruction">
          I/we being the person(s) responsible for the design, construction,
          inspection and testing of the electrical installation (as indicated by
          the signatures below), particulars of which are described above,
          having exercised reasonable skill and care when carrying out the
          design, construction, inspection and testing, hereby certify that the
          said work for which I/we have been responsible is, to the best of
          my/our knowledge and belief, in accordance with MCS Installation
          Standard MIS 3002.
        </li>
        <li className="sys_info">
          <div className="left_sec">
            <div className="info">
              <h1>Signature:</h1>
              <h2>
                {formData?.signature && (
                  <img
                    src={formData?.signature}
                    alt="signature preview"
                    style={{ height: "32px" }}
                  />
                )}
              </h2>
            </div>
            <div className="info">
              <h1>Name(s):</h1>
              <h2>{selectedInspector?.name}</h2>
            </div>
            <div className="info">
              <h1>Date</h1>
              <h2>{formData?.date}</h2>
            </div>
          </div>
          <div className="right_sec">
            <div className="info">
              <h1>Next inspection recommended after not more than:</h1>
              <h2>{formData?.nextInspectionAfter || "N/A"} Years</h2>
            </div>
            <div className="info">
              <h6>
                Comment: <p>{formData?.handoverComment || ""}</p>
              </h6>
            </div>
          </div>
        </li>
        <li className="table_col">
          <h1>
            (The extent of liability of the signatory(s) is limited to the work
            described above)
          </h1>
        </li>
      </ul>

      {/* Footer Information  */}
      <div className="hdoc_footer">
        <p>
          U Energy (Yorkshire) Ltd Registered in England and Wales Registered
          Address: Greenfield House 31 East Street Lindley Huddersfield 07592090
          VAT<br></br> Registration No: 110201112
        </p>

        <div className="f_below">
          <h2>Rev 1 {formData.date}</h2>
          <h2>F43A</h2>
        </div>
      </div>
    </div>
  );
}
